import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const industries = [
  {
    name: "FinTech & Cryptocurrency",
    description:
      "Cater to a wide range of key user and stakeholder personas with a well-crafted website that fuels growth and increases revenue.",
    img: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=600&h=400&fit=crop&crop=center",
  },
  {
    name: "E-Commerce & Retail",
    description:
      "Harness user-focused web design principles to create an unparalleled shopping experience that converts and keeps customers returning time and again.",
    img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&h=400&fit=crop&crop=center",
  },
  {
    name: "Financial Services",
    description:
      "Attract clients with a professional site founded on robust security measures and a user-focused design.",
    img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop&crop=center",
  },
  {
    name: "Healthcare",
    description:
      "Deliver secure, user-friendly digital solutions for healthcare providers, patients, and administrators.",
    img: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&h=400&fit=crop&crop=center",
  },
  {
    name: "Education",
    description:
      "Empower learning with interactive, accessible, and scalable education technology platforms.",
    img: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&h=400&fit=crop&crop=center",
  },
  {
    name: "Logistics",
    description:
      "Optimize supply chains and operations with smart, data-driven logistics solutions.",
    img: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=400&fit=crop&crop=center",
  },
];

const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3500,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const IndustriesSection = () => (
  <section style={{ backgroundImage: 'url(/static/media/services-bg.560de71b.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', padding: '60px 0' }}>
    <div className="container">
      <h2 style={{ fontWeight: 700, fontSize: "2rem", marginBottom: 12 }}>
        Industries We Serve
      </h2>
      <p style={{ maxWidth: 700, color: "#444", fontSize: "1.08rem", }}>
        We empower organizations across diverse industries with innovative software solutions and expert consultation. Our team combines deep technical expertise with industry insight to help you streamline operations, enhance customer experiences, and achieve sustainable growth—no matter your company's size or sector.
      </p>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <Slider {...sliderSettings}>
          {industries.map((industry, idx) => (
            <div key={industry.name} className="px-2 h-100">
              <div className="industry-card bg-white rounded shadow-sm p-0 w-100 d-flex flex-column h-100" style={{minHeight: 370, height: '100%'}}>
                <div style={{ height: 180, background: "#e9eaf0", display: "flex", alignItems: "center", justifyContent: "center", borderTopLeftRadius: 8, borderTopRightRadius: 8, overflow: "hidden", position: "relative" }}>
                  <img 
                    src={industry.img} 
                    alt={industry.name} 
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div style={{ display: 'none', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#666', fontSize: '0.9rem', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: '#e9eaf0' }}>
                    <div style={{ fontSize: '2rem', marginBottom: '8px' }}>🏢</div>
                    <div>{industry.name}</div>
                  </div>
                </div>
                <div style={{ padding: "24px 20px 20px 20px", flex: 1 }}>
                  <h3 style={{ fontSize: "1.1rem", fontWeight: 600, marginBottom: 10, display: "flex", alignItems: "center", gap: 8 }}>
                    {industry.name}
                  </h3>
                  <p style={{ color: "#555", fontSize: ".98rem", marginBottom: 0 }}>{industry.description}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="text-center mt-4">
        <Link to="/consultation" className="readon orange-btn" style={{ padding: "12px 32px", fontSize: "1rem", borderRadius: "6px", fontWeight: 700, textDecoration: "none", display: "inline-block", background: '#111', color: '#fff' }}>
          Request for a Free Consultation
        </Link>
      </div>
    </div>
  </section>
);

export default IndustriesSection; 